module.exports = __webpack_public_path__ + "img/rbk.2ac8b44f.png";